import React from "react";
import { hadleFilter } from "../../../Utils/filtroBusqueda";
import InputSearch from "../../../Components/FormElements/inputSearch";
import SelectAdviser from "../../../Components/selectAdviser";

export const InputsSearchByAprovation = ({
  handleChangeState,
  channel,
  params,
  setParams,
  selectedOption,
  setSelectedOption,
  options,
  searchInput,
  handleChangeSearch,
  handleChangeSelect,
  codProd,
}: any) => {
  const validateChannel = ["suscript", "admin"];

  const switchStyle = validateChannel.includes(channel)
    ? "content-form-ad"
    : "content-form";

  return (
    <>
      <div className={switchStyle}>
        <select onChange={handleChangeState}>
          {hadleFilter(codProd).map(({ value, lable }: any) => (
            <option value={value}>{lable}</option>
          ))}
        </select>

        {validateChannel.includes(channel) && (
          <SelectAdviser
            params={params}
            setParams={setParams}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        )}

        <InputSearch
          values={options}
          value={searchInput}
          onChangeInput={handleChangeSearch}
          onChangeSelect={handleChangeSelect}
        />
      </div>
    </>
  );
};
